import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import React, {useEffect} from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import {
    Avatar,
    CardActionArea,
    Checkbox,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    Switch,
    Typography
} from "@mui/material";
import StyledBadge from "../../helpers/StyledBadge";
import {grey} from "@mui/material/colors";
import {downloadUrl} from "../../Shared/commonFunction";
import moment from "moment";

function Logs({SetSelectedMenu}) {


    useEffect(()=>{
        SetSelectedMenu({
            menu:"logs",
            title:"Logs"
        })
    },[]);




    const columns = [            {
        label:"Module",
        name:"module",
    },
        {
            label:"Description",
            name:"description",
        },
        {
            label:"Action",
            name:"action",
        },
        {
            label:"Created By",
            name:"Resource.names",
        },
        {
            label:"Date",
            name:"createdAt",
            options:{
                customBodyRender:(v)=>moment(v).format("YYYY-MMM-DD HH:mm")
            }
        }];



    return <div className="w-full mb-12 px-4">
   <DatatableComponent processData={(data)=>{
            return data;
        }} elevation={1} columns={columns} url={`/api/logs`} title={"System Logs"}/>
    </div>;
}

export default connect(mapStateToProps,mapDispatchToProps) (Logs);
